import { render, staticRenderFns } from "./userPermissionSettingPage.vue?vue&type=template&id=9a46ab88&"
import script from "./userPermissionSettingPage.vue?vue&type=script&lang=ts&"
export * from "./userPermissionSettingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports